(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('sportx-collection-loader')) {
  customElements.define('sportx-collection-loader', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    initialize() {
      if (this.ready || !this.isConnected) return;
      this.grid = this.querySelector('.product-list__inner');
      this.button = this.querySelector('[data-sx-collection-more]');
      this.status = this.querySelector('[data-sx-loading-status]');
      if (!this.grid || !this.button || !this.status) return;
      this.ready = true;
      this.next = this.dataset.nextUrl;
      this.visible = this.grid.children.length;
      this.seen = new Set([...this.grid.children].map(card => this.cardKey(card)));
      this.button.addEventListener('click', () => this.loadMore());
      this.update();
    }
    cardKey(card) {
      const href = card.querySelector('a[href*="/products/"]')?.getAttribute('href');
      return href ? href.split('?')[0] : card.id;
    }
    update() {
      const cards = [...this.grid.children];
      cards.forEach((card, index) => { card.hidden = index >= this.visible; });
      const shown = Math.min(this.visible, cards.length);
      this.status.textContent = this.dataset.statusLabel.replace('SHOWN', shown).replace('TOTAL', this.dataset.total);
      const remaining = this.next ? 20 : Math.min(20, cards.length - shown);
      this.button.hidden = remaining === 0;
      this.button.textContent = this.dataset.moreLabel.replace('COUNT', remaining);
    }
    async loadMore() {
      if (this.button.disabled) return;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loadingLabel;
      const target = this.visible + 20;
      try {
        this.controller = new AbortController();
        while (this.grid.children.length < target && this.next) {
          const url = new URL(this.next, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {credentials: 'same-origin', signal: this.controller.signal});
          if (!response.ok) throw new Error('collection-request');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = doc.querySelector('sportx-collection-loader');
          const pageGrid = page?.querySelector('.product-list__inner');
          if (!pageGrid) throw new Error('collection-grid');
          if (!this.isConnected) return;
          const fragment = document.createDocumentFragment();
          for (const card of [...pageGrid.children]) {
            const key = this.cardKey(card);
            if (this.seen.has(key)) continue;
            this.seen.add(key);
            card.hidden = true;
            fragment.append(card);
          }
          const previousNext = this.next;
          this.next = page.dataset.nextUrl;
          if (this.next === previousNext) throw new Error('collection-pagination');
          this.grid.append(fragment);
        }
        this.visible = Math.min(target, this.grid.children.length);
        this.update();
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.button.textContent = this.dataset.errorLabel;
          this.status.textContent = this.dataset.errorLabel;
        }
      } finally {
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}

function initializeSmartTeamGrids(){document.querySelectorAll('[data-sx-smart-grid]').forEach(root=>{
  if(root.dataset.smartReady)return;root.dataset.smartReady='true';
  const grid=root.querySelector('[data-sx-grid-cards]');const button=root.querySelector('[data-sx-load-more]');const status=root.querySelector('[data-sx-grid-status]');const nextLink=root.querySelector('[data-sx-next-page]');
  let next=root.querySelector('[data-sx-next-page]')?.href;let visible=20;const seen=new Set([...grid.children].map(card=>card.dataset.productId));
  const update=()=>{const cards=[...grid.children];cards.forEach((card,index)=>card.hidden=index>=visible);const shown=Math.min(visible,cards.length);if(nextLink){nextLink.hidden=!next;if(next)nextLink.href=next;}status.textContent=`מוצגים ${shown} מתוך ${root.dataset.total} מוצרים`;button.hidden=shown===cards.length&&!next;button.textContent=`טען עוד ${Math.min(20,Math.max(cards.length-shown,next?20:0))} מוצרים`;};
  const getPage=async(url)=>{const request=new URL(url,location.origin);request.searchParams.set('sections',root.dataset.sectionId);const response=await fetch(request,{credentials:'same-origin'});if(!response.ok)throw new Error('request');const data=await response.json();const html=data[root.dataset.sectionId];if(!html)throw new Error('section');const doc=new DOMParser().parseFromString(html,'text/html');const section=doc.querySelector('[data-sx-smart-grid]');if(!section)throw new Error('grid');return section;};
  const prepare=async()=>{if(root.dataset.selectedSort||new URL(location.href).searchParams.has('page'))return;const needsBest=root.dataset.defaultSort!=='best-selling';const needsLatest=Number(root.dataset.total)>20;if(!needsBest&&!needsLatest)return;button.disabled=true;try{
    const bestURL=new URL(location.href);bestURL.searchParams.set('sort_by','best-selling');bestURL.searchParams.delete('page');const latestURL=new URL(bestURL);latestURL.searchParams.set('sort_by','created-descending');
    const [best,latest]=await Promise.all([needsBest?getPage(bestURL):Promise.resolve(root),needsLatest?getPage(latestURL):Promise.resolve(root)]);
    const bestCards=[...best.querySelector('[data-sx-grid-cards]').children];const allCurrent=new Map();[...grid.children,...bestCards,...latest.querySelector('[data-sx-grid-cards]').children].forEach(card=>{if(card.dataset.current==='true')allCurrent.set(card.dataset.productId,card);});
    const current=[...allCurrent.values()].sort((a,b)=>Number(b.dataset.published)-Number(a.dataset.published));const rest=bestCards.filter(card=>!allCurrent.has(card.dataset.productId));grid.replaceChildren(...current,...rest);seen.clear();[...grid.children].forEach(card=>seen.add(card.dataset.productId));next=best.querySelector('[data-sx-next-page]')?.href;update();
  }catch(error){status.textContent='אפשר להמשיך להציג את המוצרים בקולקציה.';}finally{button.disabled=false;}};
  button.addEventListener('click',async()=>{button.disabled=true;try{while(visible+20>grid.children.length&&next){const page=await getPage(next);for(const card of [...page.querySelector('[data-sx-grid-cards]').children]){if(!seen.has(card.dataset.productId)){seen.add(card.dataset.productId);grid.append(card);}}next=page.querySelector('[data-sx-next-page]')?.href;}visible+=20;update();}catch(error){button.textContent='נסה שוב לטעון מוצרים';status.textContent='הטעינה לא הושלמה. לחצו שוב כדי לנסות.';}finally{button.disabled=false;}});
  update();prepare();
});}
initializeSmartTeamGrids();document.addEventListener('shopify:section:load',initializeSmartTeamGrids);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sportx-player-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sportx-player-carousel').forEach((section) => {
    const track = section.querySelector('[data-player-track]');
    const prev = section.querySelector('[data-player-prev]');
    const next = section.querySelector('[data-player-next]');
    if (!track || !prev || !next) return;
    const amount = () => {
      const card = track.querySelector('.sportx-player-carousel__card');
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sportx-team-collection"] && !Shopify.designMode) return;
  try {
    
function initializeKidsSeasons(){document.querySelectorAll('#sx-kids').forEach(section=>{if(section.dataset.seasonsReady)return;section.dataset.seasonsReady='true';const cards=[...section.querySelectorAll('[data-sx-kids-season]')];const buttons=[...section.querySelectorAll('[data-sx-kids-filter]')];const empty=section.querySelector('.sx-team-v3__kids-empty');const select=season=>{let visible=0;cards.forEach(card=>{card.hidden=card.dataset.sxKidsSeason!==season;if(!card.hidden)visible++;});buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.sxKidsFilter===season)));empty.hidden=visible>0;section.querySelector('.sx-team-v3__rail').scrollLeft=0;};buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.sxKidsFilter)));select(cards.some(card=>card.dataset.sxKidsSeason==='summer')?'summer':'winter');});}
initializeKidsSeasons();document.addEventListener('shopify:section:load',initializeKidsSeasons);

function initializeTeamRailNavigation(){
 document.querySelectorAll('.sx-team-v3__rail,.sx-team-v3__moments-grid').forEach((rail,index)=>{
  if(rail.dataset.navigationReady)return;
  rail.dataset.navigationReady='true';
  if(!rail.id)rail.id='sx-rail-'+Date.now()+'-'+index;
  const controls=document.createElement('div');controls.className='sx-rail-controls';
  const count=document.createElement('span');
  const buttons=document.createElement('div');buttons.className='sx-rail-controls__buttons';
  const makeButton=(label,path)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',label);button.setAttribute('aria-controls',rail.id);button.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+path+'"/></svg>';buttons.append(button);return button;};
  const previous=makeButton('למוצרים הקודמים','M9 5l7 7-7 7');
  const next=makeButton('למוצרים הבאים','M15 5l-7 7 7 7');
  controls.append(count,buttons);
  const host=rail.closest('.sx-team-v3__products');
  if(host)host.prepend(controls);else rail.before(controls);
  const update=()=>{
   const cards=[...rail.children].filter(card=>!card.hidden&&getComputedStyle(card).display!=='none');
   const bounds=rail.getBoundingClientRect();
   const visible=cards.map((card,i)=>({i,r:card.getBoundingClientRect()})).filter(({r})=>Math.min(r.right,bounds.right)-Math.max(r.left,bounds.left)>Math.min(r.width*.5,bounds.width*.5));
   const overflow=rail.scrollWidth>rail.clientWidth+3;
   controls.hidden=cards.length===0;
   count.textContent=visible.length?'מוצגים '+(visible[0].i+1)+'–'+(visible[visible.length-1].i+1)+' מתוך '+cards.length+' מוצרים':cards.length+' מוצרים';
   buttons.hidden=!overflow;
   const position=Math.abs(rail.scrollLeft),maximum=rail.scrollWidth-rail.clientWidth;
   previous.disabled=position<3;next.disabled=position>=maximum-3;
  };
  const move=step=>{const rtl=getComputedStyle(rail).direction==='rtl';rail.scrollBy({left:step*(rtl?-1:1)*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
  previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
  let frame;rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
  new ResizeObserver(update).observe(rail);
  new MutationObserver(update).observe(rail,{subtree:true,attributes:true,attributeFilter:['hidden']});
  update();
 });
}
initializeTeamRailNavigation();document.addEventListener('shopify:section:load',initializeTeamRailNavigation);

  } catch(e) { console.error(e); }
})();
})();
